'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _predicates = require('../../../../common/utils/lib/predicates');

var _predicates2 = _interopRequireDefault(_predicates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    var predicateArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var runPredicates = (0, _predicates2.default)(predicateArray);
    return function (props, monitor) {
        return runPredicates({ props: props, monitor: monitor });
    };
}; // Utils


//////////////////
// WEBPACK FOOTER
// ./src/client/element/dnd/canDrop/makeCanDropFn.js
// module id = 300
// module chunks = 0